import { AppInfo } from "@mitel/cloudlink-sdk";
import { version } from './version';
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  accountsAppUrl: 'https://accounts.dev.mitel.io',
  //accountsAppUrl: 'http://dev-accounts.mitel.io:4200',
  adminUrl: 'https://admin.dev.api.mitel.io/2017-09-01',
  authUrl: 'https://authentication.dev.api.mitel.io/2017-09-01/token',
  tunnelUrl: 'https://tunnel.dev.api.mitel.io/2017-09-01',
  newTunnelUrl: 'https://tunnel.dev.api.mitel.io/api/v1',
  mivbProvisioningUrl: 'https://mivb.provisioning.dev.api.mitel.io/2017-09-01',
  clientId: '7de6ebc054bd446da812c9a9137c2bee',
  cloud: 'dev',
  stage: 'live',
  appInfo: new AppInfo({
    correlationIdPrefix: 'cl-gateway-portal-web',
		app: {
		  name: 'cl-gateway-portal-web',
		  version: version.appVersion,
		},
		enableAppHeader: true,
  })
};
